var map = {
	"./af-ZA.json": 55,
	"./bg-BG.json": 56,
	"./da-DK.json": 57,
	"./de-DE.json": 58,
	"./en-US.json": 59,
	"./es-ES.json": 60,
	"./fa-IR.json": 61,
	"./fi-FI.json": 62,
	"./fr-FR.json": 63,
	"./hu-HU.json": 64,
	"./id-ID.json": 65,
	"./it-IT.json": 66,
	"./ja-JP.json": 67,
	"./ka-GE.json": 68,
	"./nb-NO.json": 69,
	"./nl-NL.json": 70,
	"./pt-BR.json": 71,
	"./ru-RU.json": 72,
	"./sv-SV.json": 73,
	"./th-TH.json": 74,
	"./tr-TR.json": 75,
	"./uk-UA.json": 76,
	"./vi-VN.json": 77,
	"./zh-CN.json": 78,
	"./zh-TW.json": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;